module.exports = __webpack_public_path__ + "img/CPE1.75491a75.jpg";